import React from "react";

import { IconArrowLeftOutlined } from "~/components/icon";
import { type Impulse, useScoped } from "~/tools/impulse";

import { Link } from "../link";

import type { SmartHistoryQueue } from "./SmartHistoryQueue";

export interface SmartHistoryBackButtonProps {
	queue: Impulse<SmartHistoryQueue>;
}

export const SmartHistoryBackButton: React.FC<SmartHistoryBackButtonProps> = ({ queue }) => {
	const prevSmartHistoryUrl = useScoped(
		(scope) => queue.getValue(scope).at((activeIndex) => activeIndex - 1)?.url,
		[queue],
	);

	return (
		<Link
			className="-mx-3 flex h-7 w-7 shrink-0 items-center justify-center aria-disabled:cursor-not-allowed aria-disabled:text-gray-600"
			data-testid="smart-history-back"
			disabled={prevSmartHistoryUrl == null}
			onClick={() => {
				queue.setValue((current) => current.jumpTo((currentIndex) => currentIndex - 1));
			}}
			to={prevSmartHistoryUrl!}
		>
			<IconArrowLeftOutlined className="text-xs leading-none" />
		</Link>
	);
};
